<!-- https://8es9hr.axshare.com/#g&p=%E4%BA%92%E5%8A%A9%E5%9F%BA%E9%87%91%E9%80%80%E4%BF%9D%E4%BD%9C%E6%A5%AD&g=1 -->
<!-- 互助基金退保作業 -->
<template>
  <div class="row">
    <div class="col-12">
      <ListForm
        api
        :id="id"
        labelPosition="top"
        formTitle="互助基金退保作業"
        :recordToEdit="recordToEdit"
        :formType="formType"
      >
        <div class slot="listForm">
          <h3>
            <strong>生效中互助基金</strong>
          </h3>
          <workbench
            api="memberExitApply"
            :columns="columns"
            :toolbar="toolbar"
            :query="query"
            @editData="editData"
            @addData="editData('new')"
          ></workbench>
        </div>
        <div class slot="insStatus">
          <h3>
            <strong>帳務現況</strong>
          </h3>
          <workbench
            api="memberExitApply"
            :columns="paymentColumns"
            :toolbar="paymentToolbar"
            :query="paymentQuery"
            :paganationShow="false"
          ></workbench>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            plain
            @click="submit"
            v-if="!recordToEdit.isInsFinish && recordToEdit.isTermination!=1"
            >送出</el-button
          >
          <el-button plain @click="back">返回</el-button>
        </div>
      </ListForm>
    </div>
    <el-dialog
      :visible.sync="dialogForm"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <el-form>
        <el-form-item label="申請方案">
          <el-input v-model="currentEdit.applyDate" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="申請子方案">
          <el-input v-model="currentEdit.applyDate" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="申請種類">
          <el-input v-model="currentEdit.applyDate" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="申請日期">
          <el-input v-model="currentEdit.applyDate" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="加保狀態">
          <el-input v-model="currentEdit.applyDate" :disabled="true"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogForm = false" type="primary" plain
          >關閉</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListForm from "@/components/ListForm.vue";
import Workbench from "@/components/Workbench";
import { API } from "@/assets/config";
export default {
  name: "drop_out_culroc_suspension",
  components: { ListForm, Workbench },
  data() {
    return {
      id: this.$route.params.id || "new",
      api: "",
      paymentQuery: {
        action: "getInsPlanMemberPayment",
        id: this.$route.params.id,
      },
      query: {
        action: "getInsInfo",
        id: this.$route.params.id,
      },
      rules: {},
      recordToEdit: {},
      currentEdit: {},
      dialogForm: false,
      paymentToolbar: {
        // 是否全部關閉
        allClose: true,
        pageQuery: false,
        search: false,
        select: false,
        editable: false,
      },
      toolbar: {
        addable: false,
        select: false,
        removeable: false,
      },
      formType: [
        {
          type: "slot",
          slot: "listForm",
        },
        {
          type: "slot",
          slot: "insStatus",
        },
        {
          label: "退保確認完成日期",
          key: "insFinishDate",
          type: "date",
        },
      ],
      paymentColumns: [
        {
          prop: "name",
          label: "互助基金名稱",
        },
        {
          prop: "isPay",
          label: "互助費是否已收",
          renderFunction(h, scope, enumData) {
            return h("div", scope.row.isPay == 1 ? "是" : "否");
          },
        },
        {
          prop: "isCoopPay",
          label: "是否墊付",
          renderFunction(h, scope, enumData) {
            return h("div", scope.row.isCoopPay == 1 ? "是" : "否");
          },
        },
      ],
      columns: [
        {
          prop: "code",
          label: "操作",
          renderFunction(h, scope, enumData) {
            return h(
              "div",
              {
                style: {
                  "text-align": "center",
                },
              },
              [
                h(
                  "el-button",
                  {
                    props: {
                      type: "primary",
                      plain: true,
                      size: "small",
                    },
                    on: {
                      click: () => {
                        const { href } = this.$router.resolve({
                          name: "agent_surrenderroster_edit",
                          params: {
                            code: scope.row.insPlanMainCode,
                            subId: "new",
                          },
                          query: {
                            account: enumData.account,
                          },
                        });
                        window.open(
                          href,
                          "_blank",
                          "toolbar=yes, width=1300, height=900"
                        );
                      },
                    },
                  },
                  "建立退保作業"
                ),
              ]
            );
          },
        },
        {
          prop: "insPlanMainName",
          label: "申請方案",
        },
        {
          prop: "insPlanSubName",
          label: "申請子方案",
        },
        {
          prop: "underwriteStatus",
          label: "加保狀態",
          renderFunction(h, scope, enumData) {
            return h(
              "div",
              enumData.insPlanMainUnderwriteStatus[scope.row.underwriteStatus]
            );
          },
        },
      ],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      let url = API.memberExitApply + `?id=${this.id}`;
      this.$http.get(url).then((item) => {
        this.recordToEdit = Object.assign(
          {},
          this.recordToEdit,
          item.data.resultData.data
        );
      });
    },
    editData(id, row) {
      const { href } = this.$router.resolve({
        name: "agent_executiveroster_edit",
        params: {
          code: row.insPlanMainCode,
          subId: row.id,
        },
      });
      window.open(href, "_blank", "toolbar=yes, width=1300, height=900");
    },
    submit() {
      let url = API.memberExitApply + `?action=submitIns`;
      const form = new FormData();
      form.append("insFinishDate", this.recordToEdit.insFinishDate);
      form.append("id", this.id);
      let thenCB = (json) => {
        this.showAjaxSuccessMsg();
        if (json.resultData.isLplsClaim == 1) {
          this.go("member_drop_out_lpls_claim", this.id);
        } else {
          this.go("member_drop_out_settle_stock", this.id);
        }
      };
      this.mAxiosPost(url, form, thenCB);
    },
    go(name, id) {
      this.$router.push({
        name: `${name}`,
        params: {
          id: id,
        },
      });
    },
    back() {
      this.$router.push({ name: "member_drop_out" });
    },
  },
};
</script>

<style lang="scss" scoped>
.workbench ::v-deep {
  .search-input {
    vertical-align: middle;
    margin: 0px 10px 0px 0px;
    padding: 10px 0px;
  }
}
</style>

